import { ReactComponent as NotAuthorizedIcon } from "./assets/401.svg";

const Action = ({ label = "Go Back", ...rest }) => {
  return (
    <button
      size="small"
      variant="contained"
      color="primary"
      sx={{ mt: 2 }}
      {...rest}
    >
      {label}
    </button>
  );
};

const NotAuthorized = ({
  title = "You are not authorized.",
  subtitle,
  children,
  action,
  illustration,
  illustrationHeight,
}) => {
  return (
    <div className="page-wrapper" style={{ marginTop: "30px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          flexDirection: "column",
          height: "600px",
          width: "100%",
          paddingBlock: "60px",
          paddingTop:"0px",
          paddingBottom:"0px",
        }}
      >
        {illustration || <NotAuthorizedIcon />}
        <h2 style={{"marginTop":"0px","position":"relative","bottom":"40px"}}>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
        {action && <Action {...action} />}
        {children && <div>{children}</div>}
      </div>
    </div>
  );
};

export default NotAuthorized;
